import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=2630c8f5&scoped=true"
import script from "./reporting.vue?vue&type=script&lang=js"
export * from "./reporting.vue?vue&type=script&lang=js"
import style0 from "./reporting.vue?vue&type=style&index=0&id=2630c8f5&prod&scoped=true&lang=scss"
import style1 from "./reporting.vue?vue&type=style&index=1&id=2630c8f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2630c8f5",
  null
  
)

export default component.exports